import { render, staticRenderFns } from "./2-AdditionalQuestions.vue?vue&type=template&id=11377f87&scoped=true"
import script from "./2-AdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./2-AdditionalQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11377f87",
  null
  
)

export default component.exports